const paymentChannelsConfig = {
  title: 'Payment Method',
  route: 'payment-methods',
};
export { paymentChannelsConfig };
